// extracted by mini-css-extract-plugin
export var currencyInput = "_lc-1";
export var currencySymbol = "_lc-0";